
export default function (param) {
    $('.form-validate').validate(
        {
            rules : {
                name:{
                        required:true,
                        minlength:3
                },
                phone:{
                        required:true,
                        minlength:14
                },
                mail:{
                        required:true,
                        email:true
                }                                 
            },
            messages:{
                name:{
                        required:"Por favor, informe seu nome",
                        minlength:"O nome deve ter pelo menos 3 caracteres"
                },
                phone:{
                        required:"Por favor, informe seu telefone",
                        minlength:"O telefone deve ter DDD e número válido"
                },
                mail:{
                        required:"É necessário informar um e-mail",
                        email:"É necessário informar um e-mail válido",
                }      
            }
        }
    );
}